import React from 'react'
import styles from './editItem.module.sass'
import ItemInfo from './ItemInformation'
import { ToastContainer } from "react-toastify";

const EditItems = ({isChanged, setIsChanged}) => {
  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
            <ItemInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default EditItems